import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { EmailTemplate } from '../models';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {

  constructor(
      private http: HttpClient,
      private apiService: ApiService
  ) { }

  public getAllEmailTemplates(emailTemplateSearchParam:IGlobalSearchParam):Observable<any> {
    console.log(emailTemplateSearchParam);
    return this.apiService.post(`EmailTemplate/SearchEmailTemplate`,emailTemplateSearchParam)
  }




      /**
      * This method is used to get individual Email Template record based on the lemplateId
      *
      * @param  templateId  
      * @return      json result
      */
       public getEmailTemplateById(templateId:number):Observable<any> {
        return this.apiService.get(`EmailTemplate/${templateId}`)
    }

    /**
    * This method is used to post/add new Email Template record
    *
    * @param  EmailTemplate object which contains the emailTemplate record values
    * @return      json result
    */
     public postEmailTemplate(emailTemplate:EmailTemplate):Observable<any> {
        return this.apiService.post(`EmailTemplate`, emailTemplate)
    }


    /**
    * This method is used to update the existing Email Template record
    *
    * @param  template Id 
    * @param  EmailTemplate object which contains the emailTemplate record values
    * @return      json result
    */
     public updateEmailTemplate(templateId:number, emailTemplate:EmailTemplate):Observable<any> {
        return this.apiService.put(`EmailTemplate/${templateId}`, emailTemplate)
    }


    /**
    * This method is used to delete the existing Email Template record
    *
    * @param  template Id
    * @return      json result
    */
     public deleteEmailTemplate(templateId:number):Observable<any> {
        return this.apiService.delete(`EmailTemplate/${templateId}`)
    }

    public ExportEmailTemplate(emailTemplateSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}EmailTemplate/ExportEmailTemplate`, emailTemplateSearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }







}
